import PropTypes from "prop-types"
import React from "react"
import { Card, CardBody, Container } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"
import  OpsDashboardLiveWoDetails from "./OpsDashboardLiveWoDetails"
//import LiveCallsStatsTable from "./LiveCallsStatsTable"
//import SystemCallsStatsTable from "./SystemCallsStatsTable"
//import ColdCallStatsTable from "./ColdCallStatsTable"
//import UserWiseVerificationCallStatsTable from "./UserWiseVerificationCallStatsTable"
//import UserWiseLiveColdStatsTable from "./UserWiseLiveColdStatsTable"
//import UserWiseSysGenratedCallStatsTable from "./UserWiseSysGenratedCallStatsTable"

const DashboardOpsManager = props => {
  //meta title
  document.title = "Cockpit"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Operation Dashboar")}
            breadcrumbItem={props.t("Operation Dashboard")}
          />

          <Card>
            <CardBody className="border-bottom">
              <div style={{ padding: '20px' }}>
               <OpsDashboardLiveWoDetails /> 
                {/* <SystemCallsStatsTable />
                <ColdCallStatsTable />
                <UserWiseVerificationCallStatsTable />  */}
                {/* <UserWiseLiveColdStatsTable />
                <UserWiseSysGenratedCallStatsTable /> */}
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

DashboardOpsManager.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(DashboardOpsManager)